import React from 'react';
const testimonials = [{
  avatar: 'VR',
  quote: 'La primera noche que hice el Neuro-Dump tardé 8 minutos en dormirme. Antes tardaba 2 horas.',
  name: 'Valentina R.',
  location: 'Buenos Aires'
}, {
  avatar: 'MT',
  quote: 'Por fin alguien me explicó por qué mi mente no para. No me dijo respirá profundo. Me dio un sistema.',
  name: 'Marcos T.',
  location: 'Córdoba'
}, {
  avatar: 'CL',
  quote: 'El Kit 2 AM lo abrí a las 3 de la madrugada desde el celular. Me salvó esa noche.',
  name: 'Carolina L.',
  location: 'Rosario'
}];
export function HeroTestimonials() {
  return <section className="bg-cream pb-12 md:pb-20 px-4" data-id="element-265">
      <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-6" data-id="element-266">
        {testimonials.map((test, i) => <div key={i} className="bg-white p-8 rounded-xl shadow-sage-soft border-l-[3px] border-gold" data-id="element-267">
            <div className="flex items-center gap-4 mb-6" data-id="element-268">
              <div className="w-10 h-10 bg-sage rounded-full flex items-center justify-center text-cream-white font-sans font-bold text-sm" data-id="element-269">
                {test.avatar}
              </div>
              <div data-id="element-270">
                <p className="font-sans font-bold text-sage text-sm" data-id="element-271">
                  {test.name}
                </p>
                <p className="font-sans font-light text-taupe text-xs" data-id="element-272">
                  {test.location}
                </p>
              </div>
            </div>
            <p className="text-[#2D2D2D] font-sans leading-relaxed" data-id="element-273">
              "{test.quote}"
            </p>
          </div>)}
      </div>
    </section>;
}